import BgImage from '../../assets/personal-loan/personal-loan-bg.png'
import SMAppQuickCash from '../../containers/App-PersonalLoan/QuickCash'
import SMAppWhyChoose from '../../containers/App-PersonalLoan/WhyChoose'
import SMAppHowWork from '../../containers/App-PersonalLoan/HowWork'
import SMAppPLInstructionVideo from '../../containers/App-PersonalLoan/InstructionVideo'
import SMAppLicense from '../../containers/App-PersonalLoan/License'
import SMAppDownload from '../../containers/App-PersonalLoan/Download'
import SMAppRequirements from '../../containers/App-PersonalLoan/Requirements'
import AppFAQItem from '../../components/ui/AppFAQ'
import axios from 'axios'
import { FAQUrl } from '../../common/url'
import React, { useState, useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { App_Language_key } from '../../common/config'
import { ScreenWidthPort } from '../../ScreenWidthContext'
import { isTablet } from 'react-device-detect'

export const AppPersonalLoanScreen: React.FC = () => {
    const { screenWidth } = ScreenWidthPort()
    
    const { t } = useTranslation()

    const [data, setData] = useState(null)

    useEffect(() => {
        (async () => {
            await fetchList()
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const language = sessionStorage.getItem(App_Language_key) === 'ms' ? 'BM' : 'EN'
    
    const fetchList = async () => {
        try {
            var url = FAQUrl + '?publicationState=live&sort=sequence:ASC&filters[language][$eq]=' + language + '&filters[category][$eq]=Personal Loan'
            const response = await axios.get(url)
            if (response.status === 200) {
                setData(response.data['data'])
            }
        } catch (error) {
            console.error(error)
        }
    }

    const renderFaqAccordion = () => (
        <Box sx={{
            width: '100%',
            paddingLeft: '16px',
            paddingRight: '16px',
            paddingTop: '30px',
            paddingBottom: '30px',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#FFFFFF'
        }}>
            <Typography fontSize={24} fontWeight={700} color={'#141F39'} textAlign={'center'} paddingLeft={'16px'} paddingRight={'16px'}>
                {t('t164')}
            </Typography>
            <AppFAQItem data={data}></AppFAQItem>
        </Box>
    )

    // ======================= VIEWS
    return (
        <>
            <Box sx={{ position: 'relative', 
                objectFit: 'cover',
                backgroundImage: `url(${BgImage})`,                
                backgroundSize: 'cover',    
                backgroundPosition: 'center',
                width: '100%',
                height: (screenWidth * 226 / 375),
            }}>

                <Box sx={{ position: 'absolute', left: 0, top: 0, right: 0, bottom: 0, justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                    <Typography fontSize={32} fontWeight={700} color={'#FBBF23'} textAlign={'center'}>
                        {t('t205')}
                    </Typography>

                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignContent: 'center', alignItems: 'center', paddingTop: '8px'}}>
                        <Typography fontSize={14} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                            {t('t206')}
                        </Typography>
                        <Box sx={{ width: '1px', height: '20px', backgroundColor: '#FFFFFF', marginLeft: isTablet ? '15px' : '8px', marginRight: isTablet ? '15px' : '8px' }}></Box>
                        <Typography fontSize={14} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                            {t('t207')}
                        </Typography>
                        <Box sx={{ width: '1px', height: '20px', backgroundColor: '#FFFFFF', marginLeft: isTablet ? '15px' : '8px', marginRight: isTablet ? '15px' : '8px' }}></Box>
                        <Typography fontSize={14} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                            {t('t208')}
                        </Typography>
                    </Box> 
                </Box>
            </Box>
            <SMAppQuickCash />
            <SMAppWhyChoose />
            <SMAppRequirements />
            <SMAppHowWork />
            <SMAppPLInstructionVideo />
            <SMAppLicense />
            {renderFaqAccordion()}
            <SMAppDownload />
        </>
    )
}

// ======================= EXPORT
export default AppPersonalLoanScreen
